import {constructURI} from '../bip/utils'

import {usAllTerritoriesGeoJson} from '../bip/constants/MapUsAllTerritories.js'


function render(config, year) {
  renderMap(config, year)
  renderVarroaChart(config, year)
  renderNosemaChart(config, year)
  renderVirusChart(config, year)
  renderPesticideAllPieChart(config)
  renderPesticideAllHistoChart(config)
  renderPesticideYearPieChart(config, year)
  renderPesticideYearHistoChart(config, year)
  renderPesticideAllPieChartWax(config)
  renderPesticideAllHistoChartWax(config)
  renderPesticideYearPieChartWax(config, year)
  renderPesticideYearHistoChartWax(config, year)
}

function showHide(year, years_both) {
  if (year < 2017) {
    $("#waxSampleRow").hide();
    $("#breadSampleRow").show();
  }  else if (years_both.includes(year)) {
    $("#waxSampleRow").show();
    $("#breadSampleRow").show();
  } else if (year > 2020 && year < 2023) {
    $("#waxSampleRow").hide();
    $("#breadSampleRow").show();
  } else if (year > 2017) {
    $("#waxSampleRow").show();
    $("#breadSampleRow").hide();
  } else {
    $("#waxSampleRow").show();
    $("#breadSampleRow").show();
  }
}

$(function () {
  const config = JSON.parse(document.getElementById('config').textContent)
  const { initial_year, all_years = [] } = config
  let years_both = [2017, 2020, 2023]
  showHide(initial_year, years_both)
  render(config, initial_year)

  let $yearPicker = $('<select class="form-select form-select-lg"></select>')
  $('.year-picker').append($yearPicker)
  $yearPicker.append(all_years.map(year => `<option value="${year}">${year}</option>`))
  $yearPicker.val(initial_year)
  $yearPicker.on('change', () => {
    let year = parseInt($yearPicker.val())
    showHide(year, years_both)
    render(config, year)
  })
})

const perYear = year => x => x.year === year

const stateDataPerYear = (config, year) =>
  config.state_data.filter(perYear(year))

const nationalDataPerYear = (config, year) =>
  config.year_month_averages.find(perYear(year))

const nationalVirusDataPerYear = (config, year) =>
  config.molecular_prevalence_per_year.find(perYear(year))

const pesticidesByYearPerYear = (config, year) =>
  config.pesticides_by_year_bread.find(perYear(year))

const pesticidesByYearPerYearWax = (config, year) =>
  config.pesticides_by_year_wax.find(perYear(year))


function renderMap(config, year) {
  const { state_reports_result_url } = config
  const data = stateDataPerYear(config, year)


  function onClickPoint() {
    const reportURI = constructURI(state_reports_result_url, { year, state: this.state_code })
    window.open(reportURI, '_blank')
  }

  // overide the default colors to match colors used in the US map.
  Highcharts.setOptions({
    colors: ['#A1D2F7', '#69164B', '#4E4D86', '#4D79B9', '#AA80FF', '#E7F8FD', '#B300B3', '#B3B3FF', '#00CCFF']
  });

  Highcharts.mapChart('map', {
    title: {
      text: `Average Varroa per 100 Bees<br>From APHIS Survey During ${year}`
    },
    chart: {
      height: 600,
      marginTop: 100,
    },
    exporting: {
      chartOptions: { // specific options for the exported image
          plotOptions: {
              series: {
                  dataLabels: {
                      enabled: true
                  }
              }
          }
      },
      fallbackToExportServer: false
    },
    responsive: {
      rules: [
        {
          chartOptions: {
            chart: {
              height: 500,
            },
          },
          condition: {
            maxWidth: 680
          }
        }
      ]
    },
    legend: {
      layout: 'horizontal',
      borderWidth: 0,
      backgroundColor: '#e6e6e6',
      floating: true,
      verticalAlign: 'top',
      y: 50
    },
    mapNavigation: {
      buttonOptions: {
        alignTo: 'spacingBox'
      },
      enabled: true,
      enableMouseWheelZoom: false
    },
    plotOptions: {
      series: {
        nullColor: {
          pattern: {
            path: { d: 'M 0 28 L 28 0 M -4 4 L 4 -4 M 25 31 L 31 25',
                    strokeWidth: 9
            },
            color: '#b3b3b3',
            backgroundColor: '#cccccc',
            width: 28,
            height: 28,
            patternTransform: 'scale(10) rotate(90)'
          }
        },
      }
    },
    colorAxis: {
      min: .025,

      stops: [
        // Green
        [0.05, '#e7f8fd'],
         // Blue
        [0.15, '#9fd2f9'],
        [0.40, '#56b0f5'],
        // purple
        [0.77, '#5a0c41'],
        [0.90, '#430931'],
        [0.95, '#2d0621'],
        [1, '#160310']
      ]
     },

    series: [{
      data: data,
      mapData: usAllTerritoriesGeoJson,
      joinBy: ['postalcode', 'state_code'],
      dataLabels: {
        allowOverlap: true,
        enabled: true,
        color: '#FFFFFF',
        format: '{point.state_code}'
      },
      name: 'Average Varroa',
      tooltip: {
        pointFormat: '{point.postalcode}: {point.value} per 100 bees<br>from {point.nvalue} samples'
      },
      allowPointSelect: true,
      point: {
        events: {
          click: onClickPoint
        }
      }
    }]
  })
}

function renderVarroaChart(config, year) {
  const { monthly_varroa_chart, all_n } = config
  const national_data = nationalDataPerYear(config, year)

  Highcharts.chart('varroaNationalChart', {
    chart: {
      zoomType: 'xy'
    },
    title: {
      text: 'Average Varroa'
    },
    subtitle: {
      text: `Comparing National Average for All Years (n=${all_n.varroa_n})<br>to year ${year} (n=${national_data.varroa_per_100_bees_n})`
    },
    xAxis: [{
      categories: ['January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December']
    }],
    yAxis: [{ // Primary yAxis
      max: 10,
      labels: {
        format: '{value}',
        style: {
          color: Highcharts.getOptions().colors[1]
        }
      },
      title: {
        text: 'Varroa per 100 Bees',
      }
    }],
    tooltip: {
      shared: true
    },
    series: [{
      name: year,
      type: 'column',
      data: national_data.varroa_per_100_bees_data,
      tooltip: {
        pointFormat: '<span style="font-weight: bold; color: {series.color}">{series.name}</span>: <b>{point.y:.1f}</b><br>n={point.nvalue}'
      }
    }, {
      name: year + ' error',
      type: 'errorbar',
      data: national_data.varroa_per_100_bees_minmax,
      tooltip: {
        pointFormat: '<br>(95% CI: {point.low}-{point.high})<br/>'
      }
    }, {
      name: 'All Years',
      type: 'spline',
      data: monthly_varroa_chart.ushbs_data,
      tooltip: {
        pointFormat: '<span style="font-weight: bold; color: {series.color}">{series.name}</span>: <b>{point.y:.1f}</b><br>n={point.nvalue}'
      }
    }]
  })
}

function renderNosemaChart(config, year) {
  const { monthly_nosema_chart, all_n } = config
  const national_data = nationalDataPerYear(config, year)

  Highcharts.chart('nosemaNationalChart', {
    chart: {
      zoomType: 'xy'
    },
    title: {
      text: 'Average Vairimorpha'
    },
    subtitle: {
      text: `Comparing National Average for All Years (n=${all_n.nosema_n})<br>to year ${year} (n=${national_data.million_spores_per_bee_n})`
    },
    xAxis: [{
      categories: ['January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December']
    }],
    yAxis: [{ // Primary yAxis
      max: 2,
      labels: {
        format: '{value}',
        style: {
          color: Highcharts.getOptions().colors[1]
        }
      },
      title: {
        text: 'Millions of spores per bee',
      }
    }],
    tooltip: {
      shared: true
    },
    series: [{
      name: year,
      type: 'column',
      data: national_data.million_spores_per_bee_data,
      tooltip: {
        pointFormat: '<span style="font-weight: bold; color: {series.color}">{series.name}</span>: <b>{point.y:.1f}</b><br>n={point.nvalue}'
      }
    }, {
      name: year + ' error',
      type: 'errorbar',
      data: national_data.million_spores_per_bee_minmax,
      tooltip: {
        pointFormat: '<br>(95% CI: {point.low}-{point.high})<br/>'
      }
    }, {
      name: 'All Years',
      type: 'spline',
      data: monthly_nosema_chart.ushbs_data,
      tooltip: {
        pointFormat: '<span style="font-weight: bold; color: {series.color}">{series.name}</span>: <b>{point.y:.1f}</b><br>n={point.nvalue}'
      }
    }]
  })
}

function renderVirusChart(config, year) {
  const { molecular_prevalence_all_years } = config
  const national_virus_data = nationalVirusDataPerYear(config, year)

  Highcharts.chart('virus-prevalence', {
    chart: {
      type: 'column'
    },
    title: {
      text: 'Molecular Pathogen Prevalence'
    },
    subtitle: {
      text: `Comparing National Average since 2013 (n=${molecular_prevalence_all_years.nvalue})<br>to ${year} (n=${national_virus_data.nvalue})`
    },
    xAxis: {
      categories: molecular_prevalence_all_years.categories,
      crosshair: true
    },
    yAxis: {
      min: 0,
      max: 100,
      title: {
        text: '% Prevalence'
      }
    },
    tooltip: {
      headerFormat: '<span style="font-size:10px">{point.key}</span>',
      shared: true
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0
      }
    },
    series: [{
      name: year,
      data: national_virus_data.series,
      tooltip: {
        pointFormat: '<span style="font-weight: bold; color: {series.color}"><br>{series.name}</span>: <b>{point.y_tip}%</b><br>n={point.n}'
      }

    }, {
      name: 'All Years',
      data: molecular_prevalence_all_years.series,
      tooltip: {
        pointFormat: '<span style="font-weight: bold; color: {series.color}"><br>{series.name}</span>: <b>{point.y_tip}%</b><br>n={point.n}'
      }

    }]
  })
}

function renderPesticideAllPieChart(config) {
  const { pesticide_all_pie_chart_bread, all_pesticide_samples_n_bread } = config

  Highcharts.chart('pesticide-all-pie-chart', {
    chart: {
      type: 'pie'
    },
    credits: {
      enabled: false
    },
    title: {
      text: 'Pesticides Category Distribution for All Bee Bread Samples'
    },
    subtitle: {
      text: `# of bee bread samples = ${all_pesticide_samples_n_bread}`
    },
    tooltip: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        dataLabels: {
          format: '{point.name}<br>{percentage:.1f}% n={point.y}',
          style: {fontSize: '13px'},
          distance: 10
        }
      }
    },
    series: [{
      data: pesticide_all_pie_chart_bread
    }]
  })
}

function renderPesticideAllHistoChart(config) {
  const { pesticide_all_histo_chart_bread, all_pesticide_samples_n_bread } = config

  Highcharts.chart('pesticide-all-histo-chart', {
    chart: {
      zoomType: 'xy'
    },
    credits: {
      enabled: false
    },
    title: {
      text: 'Histogram of Number of Pesticides Detected per Bee Bread Sample'
    },
    subtitle: {
      text: `# of samples = ${all_pesticide_samples_n_bread}`
    },
    xAxis: {
      categories: pesticide_all_histo_chart_bread.categories,
      title: {
        text: 'Number of Pesticides per Sample'
      },
      labels: {
        step: 1
      }
    },
    legend: {
      enabled: false
    },
    yAxis: {
      title: {
        text: 'Number of Samples'
      },
      max: 250,
      tickInterval: 50
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0
      }
    },
    series: [{
      name: 'Number of Pesticides Detected',
      type: 'column',
      data: pesticide_all_histo_chart_bread.data,
      tooltip: {
        pointFormat: '<span style="font-weight: bold; color: {series.color}">Pesticides detected in </span><br> <b>{point.y}<br> Samples</b> '
      }
    }]
  })
}

function renderPesticideYearPieChart(config, year) {
  const pesticides_by_year_bread = pesticidesByYearPerYear(config, year)

  Highcharts.chart('pesticide-year-pie-chart', {
    chart: {
      type: 'pie'
    },
    credits: {
      enabled: false
    },
    title: {
      text: `Pesticides Category Distribution in ${year} Bee Bread Samples`
    },
    subtitle: {
      text: `# of bee bread samples = ${pesticides_by_year_bread.nvalue}`
    },
    tooltip: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        dataLabels: {
          format: '{point.name}<br>{percentage:.1f}% n={point.y}',
          style: {fontSize: '13px'},
          distance: 10
        }
      }
    },
    series: [{
      data: pesticides_by_year_bread.pie_chart
    }]
  })
}

function renderPesticideYearHistoChart(config, year) {
  const pesticides_by_year_bread = pesticidesByYearPerYear(config, year)

  Highcharts.chart('pesticide-year-histo-chart', {
    chart: {
      zoomType: 'xy'
    },
    credits: {
      enabled: false
    },
    title: {
      text: `Histogram of Number of Pesticides Detected per Bee Bread Sample in ${year}`
    },
    subtitle: {
      text: `# of samples = ${pesticides_by_year_bread.nvalue}`
    },
    xAxis: {
      categories: pesticides_by_year_bread.histo_chart.categories,
      crosshair: true,
      title: {
        text: 'Number of Pesticides per Sample'
      }
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Number of Samples'
      },
      tickInterval: 10

    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0
      }
    },
    series: [{
      type: 'column',
      data: pesticides_by_year_bread.histo_chart.data,
      showInLegend: false
    }]
  })
}




function renderPesticideAllPieChartWax(config) {
  const { pesticide_all_pie_chart_wax, all_pesticide_samples_n_wax } = config

  Highcharts.chart('pesticide-all-pie-chart-wax', {
    chart: {
      type: 'pie'
    },
    credits: {
      enabled: false
    },
    title: {
      text: 'Pesticides Category Distribution for All Wax Samples'
    },
    subtitle: {
      text: `# of wax samples = ${all_pesticide_samples_n_wax}`
    },
    tooltip: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        dataLabels: {
          format: '{point.name}<br>{percentage:.1f}% n={point.y}',
          style: {fontSize: '13px'},
          distance: 10
        }
      }
    },
    series: [{
      data: pesticide_all_pie_chart_wax
    }]
  })
}

function renderPesticideAllHistoChartWax(config) {
  const { pesticide_all_histo_chart_wax, all_pesticide_samples_n_wax } = config

  Highcharts.chart('pesticide-all-histo-chart-wax', {
    chart: {
      zoomType: 'xy'
    },
    credits: {
      enabled: false
    },
    title: {
      text: 'Histogram of Number of Pesticides Detected per Wax Sample'
    },
    subtitle: {
      text: `# of samples = ${all_pesticide_samples_n_wax}`
    },
    xAxis: {
      categories: pesticide_all_histo_chart_wax.categories,
      title: {
        text: 'Number of Pesticides per Sample'
      },
      labels: {
        step: 2
      }
    },
    legend: {
      enabled: false
    },
    yAxis: {
      title: {
        text: 'Number of Samples'
      },
      tickInterval: 10
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0
      }
    },
    series: [{
      name: 'Number of Pesticides Detected',
      type: 'column',
      data: pesticide_all_histo_chart_wax.data,
      tooltip: {
        pointFormat: '<span style="font-weight: bold; color: {series.color}">Pesticides detected in </span><br> <b>{point.y}<br> Samples</b> '
      }
    }]
  })
}

function renderPesticideYearPieChartWax(config, year) {
  const pesticides_by_year_wax = pesticidesByYearPerYearWax(config, year)

  Highcharts.chart('pesticide-year-pie-chart-wax', {
    chart: {
      type: 'pie'
    },
    credits: {
      enabled: false
    },
    title: {
      text: `Pesticides Category Distribution in ${year} Wax Samples`
    },
    subtitle: {
      text: `# of wax samples = ${pesticides_by_year_wax.nvalue}`
    },
    tooltip: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        dataLabels: {
          format: '{point.name}<br>{percentage:.1f}% n={point.y}',
          style: {fontSize: '13px'},
          distance: 10
        }
      }
    },
    series: [{
      data: pesticides_by_year_wax.pie_chart
    }]
  })
}

function renderPesticideYearHistoChartWax(config, year) {
  const pesticides_by_year_wax = pesticidesByYearPerYearWax(config, year)

  Highcharts.chart('pesticide-year-histo-chart-wax', {
    chart: {
      zoomType: 'xy'
    },
    credits: {
      enabled: false
    },
    title: {
      text: `Histogram of Number of Pesticides Detected per Wax Sample in ${year}`
    },
    subtitle: {
      text: `# of samples = ${pesticides_by_year_wax.nvalue}`
    },
    xAxis: {
      categories: pesticides_by_year_wax.histo_chart.categories,
      crosshair: true,
      title: {
        text: 'Number of Pesticides per Sample'
      }
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Number of Samples'
      }
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0
      }
    },
    series: [{
      type: 'column',
      data: pesticides_by_year_wax.histo_chart.data,
      showInLegend: false
    }]
  })
}
